import { render, staticRenderFns } from "./ModPuiForm.vue?vue&type=template&id=a0e5c774&"
import script from "./ModPuiForm.vue?vue&type=script&lang=js&"
export * from "./ModPuiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports